import { subscriptionActions } from "../subscription/actions";
import {
  IAddMerchantDetailsAction,
  IAddMerchantDetailsActionPayload,
  IFetchPaymentDataAction,
  IFetchPaymentPlanPayload,
  IGetMerchantDetailsAction,
  IGetMerchantDetailsByIdAction,
  IMerchantDetails,
  IPaymentInit,
  IPaymentInitiation,
  IPlansDetails,
  IRefundAmountAction,
  IRefundAmountPayload,
  ISubmitPaymentAction,
  ISubmitPaymentPayload,
  IVerifySubscriptionAction,
  IVerifySubscriptionPayload,
} from "./interface";

const actionTypePrefix = "PAYMENT/";

export const paymentActions = {
  ADD_MERCHANT_DETAILS: `${actionTypePrefix}ADD_MERCHANT_DETAILS`,
  ADD_MERCHANT_DETAILS_SUCCESS: `${actionTypePrefix}ADD_MERCHANT_DETAILS_SUCCESS`,
  ADD_MERCHANT_DETAILS_FAILURE: `${actionTypePrefix}ADD_MERCHANT_DETAILS_FAILURE`,

  GET_MERCHANT_DETAILS: `${actionTypePrefix}GET_MERCHANT_DETAILS`,
  GET_MERCHANT_DETAILS_SUCCESS: `${actionTypePrefix}GET_MERCHANT_DETAILS_SUCCESS`,
  GET_MERCHANT_DETAILS_FAILURE: `${actionTypePrefix}GET_MERCHANT_DETAILS_FAILURE`,

  GET_MERCHANT_DETAILS_BY_IDS: `${actionTypePrefix}GET_MERCHANT_DETAILS_BY_IDS`,
  GET_MERCHANT_DETAILS_BY_IDS_SUCCESS: `${actionTypePrefix}GET_MERCHANT_DETAILS_BY_IDS_SUCCESS`,
  GET_MERCHANT_DETAILS_BY_IDS_FAILURE: `${actionTypePrefix}GET_MERCHANT_DETAILS_BY_IDS_FAILURE`,

  SUBMIT_PAYMENT: `${actionTypePrefix}SUBMIT_PAYMENT`,
  SUBMIT_PAYMENT_SUCCESS: `${actionTypePrefix}SUBMIT_PAYMENT_SUCCESS`,
  SUBMIT_PAYMENT_FAILURE: `${actionTypePrefix}SUBMIT_PAYMENT_FAILURE`,

  REFUND_AMOUNT: `${actionTypePrefix}REFUND_AMOUNT`,

  FETCH_PLANS_DATA: `${actionTypePrefix}FETCH_PLANS_DATA`,
  FETCH_PLANS_DATA_SUCCESS: `${actionTypePrefix}FETCH_PLANS_DATA_SUCCESS`,
  FETCH_PLANS_DATA_FAILURE: `${actionTypePrefix}FETCH_PLANS_DATA_FAILURE`,

  PATMENT_INITIATION: `${actionTypePrefix}PATMENT_INITIATION`,
  VERIFY_SUBSCRIPTION: `${actionTypePrefix}VERIFY_SUBSCRIPTION`,
};

export const fetchPlanData = (
  planDataPayload: IFetchPaymentPlanPayload
): IFetchPaymentDataAction => {
  return {
    type: paymentActions?.FETCH_PLANS_DATA,
    payload: planDataPayload,
  };
};

export const paymentInitiation = (
  paymentInitPayload: IPaymentInitiation
): IPaymentInit => {
  return {
    type: paymentActions?.PATMENT_INITIATION,
    payload: paymentInitPayload,
  };
};

export const fetchPlanDataSuccess = (planDetails: IPlansDetails) => {
  return {
    type: paymentActions.FETCH_PLANS_DATA_SUCCESS,
    payload: {
      planDetails,
    },
  };
};
export const fetchPlanDataFailure = (error: string) => {
  return {
    type: paymentActions.FETCH_PLANS_DATA_FAILURE,
    payload: {
      error,
    },
  };
  
};

export const refundAmountAction = (
  payload: IRefundAmountPayload
): IRefundAmountAction => {
  return {
    type: paymentActions.REFUND_AMOUNT,
    payload,
  };
};
export const verifySubscription = (
  payload: IVerifySubscriptionPayload
): IVerifySubscriptionAction => {
  return {
    type: paymentActions.VERIFY_SUBSCRIPTION,
    payload,
  };
};
export const addMerchantDetailsAction = (
  payload: IAddMerchantDetailsActionPayload
): IAddMerchantDetailsAction => {
  return {
    type: paymentActions.ADD_MERCHANT_DETAILS,
    payload,
  };
};

export const addMerchantDetailsSuccessAction = (
  merchantDetails: IMerchantDetails
) => {
  return {
    type: paymentActions.ADD_MERCHANT_DETAILS_SUCCESS,
    payload: {
      merchantDetails,
    },
  };
};
export const addMerchantDetailsFailureAction = (error: string) => {
  return {
    type: paymentActions.ADD_MERCHANT_DETAILS_FAILURE,
    payload: {
      error,
    },
  };
};

export const getMerchantDetailsAction = (
  userId: string
): IGetMerchantDetailsAction => {
  return {
    type: paymentActions.GET_MERCHANT_DETAILS,
    payload: { userId },
  };
};

export const getMerchantDetailsSuccessAction = (
  merchantDetails: IMerchantDetails[]
) => {
  return {
    type: paymentActions.GET_MERCHANT_DETAILS_SUCCESS,
    payload: {
      merchantDetails,
    },
  };
};
export const getMerchantDetailsFailureAction = (error: string) => {
  return {
    type: paymentActions.GET_MERCHANT_DETAILS_FAILURE,
    payload: {
      error,
    },
  };
};

export const submitPaymentAction = (
  paymentMode: string,
  paymentData: ISubmitPaymentPayload
): ISubmitPaymentAction => {
  return {
    type: paymentActions.SUBMIT_PAYMENT,
    payload: { paymentMode, paymentData },
  };
};

export const submitPaymentSuccessAction = (payload: any) => {
  return {
    type: paymentActions.SUBMIT_PAYMENT_SUCCESS,
    payload,
  };
};
export const submitPaymentFailureAction = (error: string) => {
  return {
    type: paymentActions.SUBMIT_PAYMENT_FAILURE,
    payload: {
      error,
    },
  };
};

export const getMerchantDetailsByIdAction = (
  paymentIds: string[]
): IGetMerchantDetailsByIdAction => {
  return {
    type: paymentActions.GET_MERCHANT_DETAILS_BY_IDS,
    payload: { paymentIds },
  };
};

export const getMerchantDetailsByIdSuccessAction = (
  merchantDetails: IMerchantDetails[]
) => {
  return {
    type: paymentActions.GET_MERCHANT_DETAILS_BY_IDS_SUCCESS,
    payload: {
      merchantDetails,
    },
  };
};

export const getMerchantDetailsByIdFailureAction = (error: string) => {
  return {
    type: paymentActions.GET_MERCHANT_DETAILS_BY_IDS_FAILURE,
    payload: {
      error,
    },
  };
};
